import '@skyslope/apps-menu/index.css';
import React from 'react';
import { useSearchParams } from '@/hooks';
import useUserInfo from '../../auth/useUserInfo';
import { useIsSmallScreenMediaQuery } from '../../lib/isSmallScreen';
import CollapseOnScroll from '../CollapseOnScroll';
import { type LaunchDarklyFlags } from '../launchDarkly';
import { getUserAdminRoles } from '../utils';
import HeaderTitle from './HeaderTitle';
import { SkyslopeAppsMenu } from './SkyslopeAppsMenu';
import UserMenu from './UserMenu';

interface IBreadcrumb {
  name: string;
  onClick: () => void;
}

interface NavHeaderProps {
  labelName: string;
  breadcrumb?: IBreadcrumb;
  progressBarPercent?: number;
  hideNavItems?: boolean;
  preferencesUrl?: string;
  showPreferences?: boolean;
  onSharingPage?: boolean;
  getUsersGroups?: any;
  flags?: LaunchDarklyFlags;
  useDefaultHeader?: boolean;
}

function NavHeader(props: NavHeaderProps) {
  const {
    labelName,
    breadcrumb,
    progressBarPercent,
    hideNavItems,
    preferencesUrl,
    showPreferences,
    onSharingPage,
    getUsersGroups,
    flags,
    useDefaultHeader = true,
  } = props;

  const { senderFirstName, senderLastName } = useUserInfo() ?? {};

  const isSmallScreen = useIsSmallScreenMediaQuery();
  const search = useSearchParams();
  const [user, setUser] = React.useState<{ isBrokerAdmin: boolean; isGroupAdmin: boolean }>({
    isBrokerAdmin: false,
    isGroupAdmin: false,
  });

  React.useEffect(() => {
    getUserAdminRoles(setUser, getUsersGroups);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- This code was written prior to enforcing lint rules
  }, []);

  return (
    <span className="flex justify-between">
      <HeaderTitle
        onSharingPage={onSharingPage}
        name={labelName}
        breadcrumb={breadcrumb}
        progressBarPercent={progressBarPercent}
      />
      {useDefaultHeader && !hideNavItems && !isSmallScreen && search.theme !== 'agnostic' ? (
        <CollapseOnScroll disableCollapse={!onSharingPage}>
          <span className="flex items-start">
            <SkyslopeAppsMenu />
            <UserMenu
              senderFirstName={senderFirstName || ''}
              senderLastName={senderLastName || ''}
              showPreferences={showPreferences}
              preferencesUrl={preferencesUrl}
              user={user}
              showBrokerManagement={flags?.['enable-broker-management-link']}
            />
          </span>
        </CollapseOnScroll>
      ) : null}
    </span>
  );
}

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default NavHeader;
